import React, { useState, useCallback, useEffect, useMemo } from "react";
import { useEpg } from "planby";
import moment from "moment";
import { useDispatch,useSelector } from "react-redux";
import { theme } from "./helpers/theme";
import { fetchLiveChannels } from "./service";
import { getLiveScheduleData } from "../../Redux/LiveScheduleData/liveScheduleDataSlice";

export function useApp({ selectedCategory }) {
  const [channels, setChannels] = React.useState([]);
  const [epg, setEpg] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useDispatch();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const epgHourWidth = projectInfo?.projectConfig?.config?.EPG_HOUR_WIDTH_WEBSITE
  ? projectInfo.projectConfig.config.EPG_HOUR_WIDTH_WEBSITE
  : 14000;

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    sessionId,
  };
  const startDate = moment().format('YYYY-MM-DD') + 'T' + "00:00:00";
  const getEndDate = () => {
    const today = moment().format("YYYY-MM-DD");
    const  formattedDate = moment(today).add(2, 'days').format("YYYY-MM-DD") + "T00:00:00";
    return formattedDate;
  }

  
  const { getEpgProps, getLayoutProps } = useEpg({
    channels: channels,
    epg: epg,
    dayWidth: epgHourWidth,
    sidebarWidth: 100,
    itemHeight: 80,
    isSidebar: true,
    isTimeline: true,
    isLine: true,
    // startDate: getCurrentTimeAndDate(),
    // endDate: convertUTCToLocal("2023-05-17T24:00:00"),
    startDate: startDate,
    endDate: getEndDate(),
    // endDate: "2023-05-24T24:00:00",
    isBaseTimeFormat: true,
    isCurrentTime: true,
    theme,
  });
 
  const handleFetchResources = React.useCallback(async () => {
    setIsLoading(true);
    const liveData = await getLiveChannels();
    setIsLoading(false);
  }, []);

  const handleKeyNameChange = (array, type) => {
    if (type === "channels") {
      return array.map((item) => ({
        uuid: item?.id,
        type: item?.type,
        title: item?.channel_name,
        logo: item?.logo,
      }));
    } else {
      return array.map((item) => ({
        ...item,
        channelUuid: item?.channel_id,
        title: item?.title,
        description: item?.video_description,
        image: item?.image,
        since: item?.start,
        till: item?.end,
        // since:item?.starttime,
        // till:item?.endtime
      }));
    }
  };
  const getLiveChannels = async () => {
    const response = await fetchLiveChannels(appInfo);
    if (response?.status === 200) {
        localStorage.setItem("fastChannel","true")
      dispatch(
        getLiveScheduleData({
          liveSchedule: response?.data?.data,
        })
      );
      // let channelsData = response?.data?.data?.channels?.filter((item)=>item?.id===370 || item?.id === 385 || item?.id === 371 );
      let channelsData = response?.data?.data?.channels
      // let epgData = response?.data?.data?.schedules?.filter((item)=>item?.channel_id===370 || item?.channel_id === 385 || item?.channel_id === 371);
      let epgData = response?.data?.data?.schedules
      setChannels(handleKeyNameChange(channelsData, "channels"));
      setEpg(handleKeyNameChange(epgData, "epg"));
    }
  };

  const fetchChannelsAndEpg = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetchLiveChannels(appInfo);
      if (response?.status === 200) {
       
        const channelsData = response?.data?.data?.channels || [];
        const epgData = response?.data?.data?.schedules || [];

        if (selectedCategory?.category_id) {
          const filteredChannelsData = channelsData.filter(channel =>
            channel.categories.some(category => category.category_id === selectedCategory.category_id)
          );
        
          const filteredChannelIds = filteredChannelsData.map(channel => channel.id);
          const filteredEpgData = epgData.filter(schedule =>
            filteredChannelIds.includes(schedule.channel_id)
          );
        
          setChannels(handleKeyNameChange(filteredChannelsData, "channels"));
          setEpg(handleKeyNameChange(filteredEpgData, "epg"));
        } else {
          setChannels(handleKeyNameChange(channelsData, "channels"));
          setEpg(handleKeyNameChange(epgData, "epg"));
        }
        

        dispatch(
          getLiveScheduleData({
            liveSchedule: {
              ...response.data.data,
              channels: channelsData,
              schedules: epgData,
            },
          })
        );
      }
    } catch (error) {
      console.error("Error fetching live channels:", error);
    }
    setIsLoading(false);
  }, [selectedCategory]);

  React.useEffect(() => {
    fetchChannelsAndEpg();
  }, [fetchChannelsAndEpg]);
  return { getEpgProps, getLayoutProps, isLoading, channels };
}
